export default __webpack_public_path__ + "static/media/i.6ff9c189.jpg";